module.exports = __webpack_public_path__ + "svg/close-red.svg?e8f047d3a52f48ec5c3708d9c88fc6b8";